<template>
  <Card class="analytics">
    <template #default>
      <slot name="top" />
      <Loader :value="promise" theme="default">
        <LineChart v-if="data" class="analytics__chart" :chart-data="chartData" :options="chartOptions" />
        <div v-else class="analytics__error">
          <FontAwesomeIcon :icon="['fal', 'snooze']" size="2x" />
          <div>{{ $t('noAnalyticsCollected') }}</div>
        </div>
      </Loader>
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </Card>
</template>

<script>
import moment from 'moment'
import API from '@/api/Analytics'

import LineChart from '@/components/Charts/ChartJS/Line'
import Card from '@/components/Card'

export default {
  props: {
    filter: Object,
  },
  watch: {
    filter: {
      handler: 'fetch',
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      data: null,
      range: {
        start: moment().subtract(1, 'month'),
        end: moment(),
      },
    }
  },
  computed: {
    chartData() {
      return {
        type: 'line',
        labels: this.data.map(d => moment(d.date).format('D. MMM')),
        datasets: [
          {
            backgroundColor: this.getColor('primary', 0.2),
            borderColor: this.getColor('primary'),
            fill: true,
            cubicInterpolationMode: 'monotone',
            data: this.data.map(e => e.pageviews),
          },
        ],
      }
    },
    chartOptions() {
      return {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: true,
            },
          },
          x: {
            grid: {
              display: false,
            },
          },
        },
      }
    },
  },
  methods: {
    fetch() {
      this.data = null
      this.promise = API.getData({
        ...this.filter,
      }).then(({ data }) => (this.data = data))
    },
    getColor(key, opacity = 1) {
      let [h, s, l] = ['h', 's', 'l'].map(k =>
        getComputedStyle(document.documentElement).getPropertyValue(`--${key}-${k}`),
      )

      return `hsla(${h}, ${s}, ${l}, ${opacity})`
    },
  },
  components: {
    Card,
    LineChart,
  },
}
</script>

<style lang="scss">
.analytics {
  &__chart,
  &__error {
    height: 340px;
  }

  &__error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    opacity: 0.4;
    font-size: 0.8em;
    font-style: italic;
    max-width: 250px;
    margin: 0 auto;

    svg {
      margin-bottom: 1rem;
    }
  }
}
</style>
